



















































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { ColumnDisplayOption } from '@/models/ColumnDisplayOption';
import { SortChangedEvent } from '@/models/SortChangedEvent';
import { IPagedCollection } from 'performo-api';

/**
 * A generic List component, to display lists (tables) of data with a card view fall back for small screens.
 */
@Component({
  components: {}
})
export default class List extends Vue {
  @Prop({ required: true }) listColumns!: ColumnDisplayOption[];
  @Prop({ required: false }) secondRowColumn!: string;
  @Prop({ required: true }) items!: [];
  @Prop({ required: true, default: 0 }) itemKey!: number | string;
  @Prop({ required: false, default: undefined }) pagination!: IPagedCollection;

  @Prop({ required: false, default: false, type: Boolean }) noHover!: boolean;

  @Prop({ required: false, default: undefined }) layoutMode!: string;

  @Prop({ required: false, default: '' }) sortColumn!: string;
  @Prop({ required: false, default: 1 }) sortDirection!: number;

  get doPagination(): boolean {
    if (this.pagination) return true;
    return false;
  }

  private cardMode = false;

  // TODO: after upgrade to typescript 4.2+, use ResizeObserver to target specific elements and get some debounce
  private handleResize() {
    const tbl = this.$refs.table as HTMLTableElement;
    if (tbl) {
      const tableWidth = tbl.parentElement?.offsetWidth;
      if (this.layoutMode && tableWidth) {
        // we have a card mode specified, check that.
        if (this.layoutMode === 'card-always') {
          this.cardMode = true;
          return;
        } else if (this.layoutMode === 'list-always') {
          this.cardMode = false;
          return;
        } else if (this.layoutMode === 'card-parent') {
          this.cardMode = tableWidth < this.$vuetify.breakpoint.thresholds.sm;
          return;
        }
      }

      // not specified use default options
      if (this.$vuetify.breakpoint.smAndDown) {
        this.cardMode = true;
        return;
      }

      this.cardMode = false;
    }
  }

  private mounted() {
    window.addEventListener('resize', this.handleResize);
    // initially handle the current size
    this.handleResize();
  }
  private destroy() {
    window.removeEventListener('resize', this.handleResize);
  }

  private handleHeaderKeydown(e: KeyboardEvent) {
    const keyD = e.key;

    if (keyD === 'Enter' || ['Spacebar', ' '].indexOf(keyD) >= 0) {
      // In IE11 and lower, e.key will equal "Spacebar" instead of ' '

      // Default behavior is prevented to prevent the page to scroll when "space" is pressed
      e.preventDefault();
      // convert to element
      let el = e.target as HTMLElement;
      // simulate click
      el.click();
    }
  }

  private handleHeaderClicked(column: ColumnDisplayOption) {
    // if the th is sortable, emit the headerClicked event
    if (!column.dontSort) {
      const direction = this.sortDirection === 1 ? 0 : 1;
      const sortChanged: SortChangedEvent = {
        column: column.columnName,
        direction: direction
      };
      this.$emit('update:sort', sortChanged);
    }
    this.$emit('header-clicked', column);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private handleRowClicked(item: any) {
    this.$emit('row-clicked', item);
  }

  private goPageForward() {
    // do page forward things
    this.$emit('update:pagination', (this.pagination.pageNumber || 1) + 1);
  }

  private goPageBackward() {
    // do page backward things
    this.$emit('update:pagination', (this.pagination.pageNumber || 1) - 1);
  }
}
